var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Loader } from '../../components/Loader/Loader';
import { LoaderType } from '../../components/Loader/LoaderType.enum';
import { tvAuthService } from '../../services/TvAuthService';
import { withTranslation } from 'react-i18next';
import { setInitialPasswordButtonLinkConstants } from './Set-initial-password-constants';
var SetInitialPassword = (function (_super) {
    __extends(SetInitialPassword, _super);
    function SetInitialPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (name, value) {
            if (name === 'password') {
                _this.setState({ password: value, isValidPassword: '', confirmPassword: '', passwordMismatch: '' });
            }
            else {
                _this.setState({ confirmPassword: value, passwordMismatch: '' });
            }
        };
        _this.callIfEnter = function (event, callback, value, name) {
            var _a = _this.state, password = _a.password, passwordMismatch = _a.passwordMismatch;
            if (event && event.key === 'Enter' && callback && callback instanceof Function) {
                if (name === 'confirmPassword' && value) {
                    {
                        password === value ? _this.setState({ passwordMismatch: false }) : _this.setState({ passwordMismatch: true });
                    }
                    if (!passwordMismatch && passwordMismatch !== '')
                        callback();
                }
            }
        };
        _this.callIfKeyPressed = function (event) {
            var element = document.getElementById('confirmPassword');
            var removeClass = element && element.closest('.s20-form-input--md');
            if (event && (event.key === 'Backspace' || event.key === 'Delete')) {
                if (element) {
                    element.setAttribute('value', '');
                    removeClass && removeClass.classList.remove('s20-form-input--md-active');
                }
            }
        };
        _this.getUrlParams = function (params) {
            var urlParams = new URLSearchParams(location.search.replace('#/', ''));
            return urlParams && urlParams.get(params) || '';
        };
        _this.handleSave = function () {
            var _a = _this.state, password = _a.password, isValidPassword = _a.isValidPassword, passwordMismatch = _a.passwordMismatch, isError = _a.isError;
            if (_this.getUrlParams('msisdn') && _this.getUrlParams('otp') && isValidPassword && !passwordMismatch && !isError) {
                _this.setState({ isLoading: true });
                tvAuthService.setPassword(_this.getUrlParams('msisdn'), password, _this.getUrlParams('otp'), _this.updateSuccess, _this.updateError, 'TV_PWD_LINK');
            }
            else if (!passwordMismatch) {
                _this.setState({ isError: true, isLoading: false });
            }
        };
        _this.updateSuccess = function () {
            _this.setState({ isSuccess: true, isLoading: false });
        };
        _this.updateError = function (response) {
            _this.setState({ isError: true, errorCode: response.errorCode, isLoading: false });
        };
        _this.handleSuccess = function () {
            var t = _this.props.t;
            return (React.createElement("div", { className: 'form_alert form_alert-ok', role: 'alert' },
                React.createElement("h2", { className: 'form_alert--heading' }, t("SetPassword.Password.Title.Success")),
                React.createElement("div", { className: 'form_alert__flex_container' },
                    React.createElement("div", null,
                        React.createElement("i", { className: 'form_alert--icon icon' })),
                    React.createElement("div", { className: 'form_alert--list--content' },
                        React.createElement("ul", { className: 'form_alert--list' },
                            React.createElement("li", null,
                                React.createElement("span", null, t("SetPassword.Password.Info.Success"))))))));
        };
        _this.handleBlur = function (value, name) {
            var password = _this.state.password;
            var regExp = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,20}$)/;
            if (name === 'password' && value) {
                {
                    regExp.test(value) ? _this.setState({ isValidPassword: true }) : _this.setState({ isValidPassword: false });
                }
            }
            if (name === 'confirmPassword' && value) {
                {
                    password === value ? _this.setState({ passwordMismatch: false }) : _this.setState({ passwordMismatch: true });
                }
            }
        };
        _this.state = {
            isLoading: false,
            password: '',
            confirmPassword: '',
            passwordMismatch: '',
            isValidPassword: '',
            isSuccess: false,
            isError: false,
            errorCode: ''
        };
        return _this;
    }
    SetInitialPassword.prototype.renderTitle = function () {
        var t = this.props.t;
        return (React.createElement("div", { className: 's20-section-title' },
            React.createElement("h2", { className: 's20-section-title__heading' }, t && t("SetPassword.Title")),
            React.createElement("p", { className: 's20-section-title__description' }, t && t("SetPassword.TitleInfo"))));
    };
    SetInitialPassword.prototype.renderSaveButton = function () {
        var _a = this.state, password = _a.password, confirmPassword = _a.confirmPassword;
        var t = this.props.t;
        return (React.createElement("div", { className: 's20-form-buttons__item' },
            React.createElement("button", { onClick: this.handleSave, className: 's20-button s20-button--full', disabled: !(password && confirmPassword) }, t && t("SetPassword.Button.Save"))));
    };
    SetInitialPassword.prototype.renderFormButtons = function () {
        return (React.createElement("div", { className: 's20-form-buttons' }, this.renderSaveButton()));
    };
    SetInitialPassword.prototype.renderPasswordField = function () {
        var _this = this;
        var _a = this.state, password = _a.password, isValidPassword = _a.isValidPassword;
        var t = this.props.t;
        var addClass = '';
        if (password && isValidPassword !== '') {
            (!isValidPassword ? addClass = 'is-error' : addClass = 'is-success');
        }
        return (React.createElement("div", { className: "s20-form-item s20-form-item--no-spacing " + addClass },
            React.createElement("div", { className: 's20-form-input s20-form-input--password s20-form-input--md s20-form-input--group' },
                React.createElement("label", { className: 's20-form-label', htmlFor: 'password' }, t && t("SetPassword.Password.Label")),
                React.createElement("input", { id: 'password', name: 'password', type: 'password', value: password, className: 's20-form-input__field', onKeyDown: function (event) { return _this.callIfKeyPressed(event); }, onChange: function (e) { return _this.handleChange(e.target.name, e.target.value); }, onBlur: function (e) { return _this.handleBlur(e.target.value, e.target.name); }, autoComplete: 'new-password' }),
                React.createElement("div", { className: 's20-form-input__button s20-form-input__button--tooltip' },
                    React.createElement("button", { className: 'js-tooltip tooltip--trigger button_infoicon button_infoicon-v2', type: 'button' },
                        React.createElement("span", { className: 'js-tooltip--content tooltip--content' },
                            React.createElement("strong", { className: 'tooltip--flyout--title' }, t && t("SetPassword.Password.ToolTip.Title")),
                            t && t("SetPassword.Password.ToolTip.Info"))))),
            addClass === 'is-error' ? React.createElement("div", { className: 's20-form-note' }, t && t("SetPassword.Password.NotStrong.Error")) : null));
    };
    SetInitialPassword.prototype.renderConfirmPasswordField = function () {
        var _this = this;
        var _a = this.state, confirmPassword = _a.confirmPassword, passwordMismatch = _a.passwordMismatch, password = _a.password;
        var t = this.props.t;
        var addClass = '';
        if (confirmPassword && passwordMismatch !== '') {
            (passwordMismatch ? addClass = 'is-error' : addClass = 'is-success');
        }
        return (React.createElement("div", { className: "s20-form-item s20-form-item--no-spacing " + addClass },
            React.createElement("div", { className: 's20-form-input s20-form-input--password s20-form-input--md s20-form-input--group' },
                React.createElement("label", { className: 's20-form-label', htmlFor: 'confirmPassword' }, t && t("SetPassword.ConfirmPassword.Label")),
                React.createElement("input", { name: 'confirmPassword', id: 'confirmPassword', type: 'password', value: confirmPassword, className: 's20-form-input__field', onKeyDown: function (event) { return _this.callIfEnter(event, _this.handleSave, confirmPassword, 'confirmPassword'); }, disabled: !password, onChange: function (e) { return _this.handleChange(e.target.name, e.target.value); }, onBlur: function (e) { return _this.handleBlur(e.target.value, e.target.name); } }),
                React.createElement("div", { className: 's20-form-input__button s20-form-input__button--tooltip' },
                    React.createElement("button", { className: 'js-tooltip tooltip--trigger button_infoicon button_infoicon-v2', type: 'button' },
                        React.createElement("span", { className: 'js-tooltip--content tooltip--content' },
                            React.createElement("strong", { className: 'tooltip--flyout--title' }, t && t("SetPassword.ConfirmPassword.ToolTip.Title")),
                            t && t("SetPassword.ConfirmPassword.Tooltip.Info"))))),
            passwordMismatch ? React.createElement("div", { className: 's20-form-note' }, t && t("SetPassword.Password.Mismatch.Error")) : null));
    };
    SetInitialPassword.prototype.handleError = function () {
        var t = this.props.t;
        var errorCode = this.state.errorCode;
        return (React.createElement("div", { className: 'form_alert form_alert-error', role: 'alert' },
            React.createElement("h2", { className: 'form_alert--heading' }, t("SetPassword.Error.Title")),
            React.createElement("div", { className: 'form_alert__flex_container' },
                React.createElement("div", null,
                    React.createElement("i", { className: 'form_alert--icon icon' })),
                React.createElement("div", { className: 'form_alert--list--content' },
                    React.createElement("ul", { className: 'form_alert--list' },
                        React.createElement("li", null,
                            React.createElement("a", null, errorCode ? t("SetPassword.Error." + errorCode) : t("SetPassword.Error.Label"))))))));
    };
    SetInitialPassword.prototype.renderSetPassword = function () {
        var isLoading = this.state.isLoading;
        return (React.createElement("div", { className: 'l-center-s' },
            isLoading ? React.createElement(Loader, { type: LoaderType.LIGHT }) : null,
            this.renderTitle(),
            React.createElement("div", { className: 's20-spacer s20-spacer--x24 is-hidden-desktop' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x32 is-hidden-mobile' }),
            this.renderPasswordField(),
            React.createElement("div", { className: 's20-spacer s20-spacer--x8' }),
            this.renderConfirmPasswordField(),
            React.createElement("div", { className: 's20-spacer s20-spacer--x24 is-hidden-desktop' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x32 is-hidden-mobile' }),
            this.renderFormButtons()));
    };
    SetInitialPassword.prototype.renderCustomButtons = function () {
        var t = this.props.t;
        return (React.createElement("div", { className: "flex social-btns" },
            React.createElement("a", { className: "app-btn blu flex vert", href: setInitialPasswordButtonLinkConstants.IOS_APP_LINK },
                React.createElement("div", { className: 'app-download-ios-icon' }),
                React.createElement("p", null,
                    t && t("SetPassword.IosButton.LabelHeader"),
                    " ",
                    React.createElement("br", null),
                    React.createElement("p", { className: "big-txt" }, t && t("SetPassword.IosButton.LabelSubHeader")))),
            React.createElement("a", { className: "app-btn blu flex vert", href: setInitialPasswordButtonLinkConstants.ANDROID_APP_LINK },
                React.createElement("div", { className: 'app-download-android-icon' }),
                React.createElement("p", null,
                    React.createElement("span", { className: "small-txt" }, t && t("SetPassword.AndroidButton.LabelHeader")),
                    " ",
                    React.createElement("br", null),
                    React.createElement("span", { className: "big-txt" }, t && t("SetPassword.AndroidButton.LabelSubHeader"))))));
    };
    SetInitialPassword.prototype.fetchURL = function () {
        if (this.getUrlParams('isStb') && !(JSON.parse(this.getUrlParams('isStb')))) {
            switch (this.getUrlParams('lang')) {
                case setInitialPasswordButtonLinkConstants.EN: return setInitialPasswordButtonLinkConstants.EN_SETUP;
                case setInitialPasswordButtonLinkConstants.FR: return setInitialPasswordButtonLinkConstants.FR_SETUP;
                case setInitialPasswordButtonLinkConstants.IT: return setInitialPasswordButtonLinkConstants.IT_SETUP;
                default: return setInitialPasswordButtonLinkConstants.DE_SETUP;
            }
        }
        return setInitialPasswordButtonLinkConstants.TV_AUTH_SETUP;
    };
    SetInitialPassword.prototype.render = function () {
        var t = this.props.t;
        var _a = this.state, isSuccess = _a.isSuccess, isError = _a.isError;
        if (isSuccess) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 's20-spacer s20-spacer--x16 is-hidden-desktop' }),
                React.createElement("div", { className: 's20-spacer s20-spacer--x64 is-hidden-mobile' }),
                this.handleSuccess(),
                React.createElement("div", { className: 's20-spacer s20-spacer--x16 is-hidden-desktop' }),
                React.createElement("div", { className: 's20-spacer s20-spacer--x64 is-hidden-mobile' }),
                React.createElement("p", { className: "social_btns_header_text" }, t && t("SetPassword.SocialButton.HeaderText")),
                this.renderCustomButtons(),
                React.createElement("div", { className: 's20-spacer s20-spacer--x16 is-hidden-desktop' }),
                React.createElement("div", { className: 's20-spacer s20-spacer--x64 is-hidden-mobile' }),
                React.createElement("div", { className: 'tv_setup_link_wrapper' },
                    React.createElement("a", { className: 'tv_setup_link_content', href: this.fetchURL() }, t && t("SetPassword.TvSetup.Text")),
                    React.createElement("div", { className: 'app-download-right-icon' }))));
        }
        else if (isError) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 's20-spacer s20-spacer--x16 is-hidden-desktop' }),
                React.createElement("div", { className: 's20-spacer s20-spacer--x64 is-hidden-mobile' }),
                this.handleError()));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 's20-spacer s20-spacer--x16 is-hidden-desktop' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x64 is-hidden-mobile' }),
            React.createElement("div", { className: 'l-center-m' },
                React.createElement("div", { className: 'content-box content-box--form' }, this.renderSetPassword())),
            React.createElement("div", { className: 's20-spacer s20-spacer--x16 is-hidden-desktop' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x64 is-hidden-mobile' })));
    };
    return SetInitialPassword;
}(React.Component));
export default withTranslation()(SetInitialPassword);
